<template>
  <div v-if="question != null">
    <div
      class="mb-10"
      v-if="question.audio != null && question.audio != ''"
      id="audio-container"
    >
      <div class="article-title mb-2">จากคลิปเสียง</div>

      <v-sheet rounded style="border: 1px solid #d3d3d3; padding: 4px">
        <vue-plyr :options="audioControls">
          <audio>
            <source :src="question.audio" type="audio/mp3" />
          </audio>
        </vue-plyr>
      </v-sheet>
    </div>

    <div class="mb-6" v-if="question.video != null && question.video != ''">
      <p class="subtitle mb-2">จากวิดิโอ</p>
      <iframe
        v-if="question.video !== ''"
        :src="`https://fleet.byteark.com/player?url=${question.video}`"
        class="resonsive-iframe"
        width="100%"
        height="250"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>

    <div class="mb-6" v-if="question.articleQuestion != null">
      <p class="subtitle mb-4">จากบทความ</p>
      <!-- <v-alert icon="far fa-book" text border="left" color="info" colored-border dense>บทความ</v-alert> -->
      <div
        class="article-content"
        v-html="question.articleQuestion.article"
        ref="articleContainer"
        id="articleContainer"
      ></div>

      <!-- <v-divider class="mb-3"></v-divider> -->
    </div>

    <div class="d-flex">
      <div class="question font-weight-bold">{{ question.priority + 1 }}.</div>
      <div>
        <div
          v-html="question.question"
          class="question font-weight-bold"
          ref="questionContainer"
          id="questionContainer"
        ></div>
      </div>
    </div>
    <v-overlay :value="overlay">
      <pinch-zoom v-bind:properties="myProperties">
        <img :src="imgPinch" />
      </pinch-zoom>
      <v-btn class="ma-2 btn-close" fab dark small @click="overlay = false">
        <v-icon>far fa-times</v-icon>
      </v-btn>
    </v-overlay>
  </div>
</template>

<script>
// import VRuntimeTemplate from "v-runtime-template";
import PinchZoom from "vue-pinch-zoom";
import EventBus from "../plugins/event-bus";

const videoControls = {
  controls: ["play-large", "play", "current-time", "fullscreen"],
};
const audioControls = {
  controls: ["play", "progress", "current-time"],
};
export default {
  components: {
    PinchZoom,
  },
  props: ["question"],
  data: () => ({
    audioControls,
    videoControls,
    overlay: false,
    myProperties: {
      overflow: "visible",
    },
    imgPinch: null,
    audioState: 0,
  }),
  computed: {
    platform() {
      let pf = this.$route.query.platform || "web";
      return pf;
    },
  },
  mounted() {
    // when DOM updated
    this.$nextTick().then(() => {
      // find img
      if (this.question.articleQuestion != null) {
        let imgs = this.$refs.articleContainer.querySelectorAll("img");
        for (let img of imgs) {
          // img.style.maxWidth = "100%";
          // img.style.height = "auto";
          img.addEventListener("click", (e) => {
            this.showOverlay(e);
          });
        }

        let links = this.$refs.articleContainer.querySelectorAll("a");
        for (let link of links) {
          // img.style.maxWidth = "100%";
          // img.style.height = "auto";
          link.addEventListener("click", (e) => {
            e.preventDefault();
            EventBus.$emit("internalBrowser", e.target.href);
          });
        }
      }

      // binding img click in question
      let imgsInQuestion = this.$refs.questionContainer.querySelectorAll("img");
      for (let img of imgsInQuestion) {
        // img.style.maxWidth = "100%";
        // img.style.height = "auto";
        img.addEventListener("click", (e) => {
          this.showOverlay(e);
        });
      }

      let linksInQuestion = this.$refs.questionContainer.querySelectorAll("a");
      for (let link of linksInQuestion) {
        // img.style.maxWidth = "100%";
        // img.style.height = "auto";
        link.addEventListener("click", (e) => {
          e.preventDefault();
          EventBus.$emit("internalBrowser", e.target.href);
        });
      }
    });
  },
  methods: {
    showOverlay(e) {
      this.imgPinch = e.target.src;
      this.overlay = true;
    },
    toggleFullscreen(e) {
      // console.log(e);

      if (!document.fullscreenElement) {
        e.target.requestFullscreen().catch((err) => {
          alert(
            `Error attempting to enable full-screen mode: ${err.message} (${err.name})`
          );
        });
      } else {
        try {
          document.exitFullscreen();
        } catch (error) {}
      }
    },
    mediaControl(cmd) {
      try {
        switch (cmd) {
          case "playAudio":
            if (typeof playAudio !== "undefined") {
              playAudio.postMessage(this.question.audio);
            }
            this.audioState = 1; // 1 is played
            break;
          case "pauseAudio":
            if (typeof pauseAudio !== "undefined") {
              pauseAudio.postMessage("pause");
            }
            this.audioState = 2; // 2 is pause
            break;
          case "stopAudio":
            if (typeof stopAudio !== "undefined") {
              stopAudio.postMessage("stop");
            }
            this.audioState = 0; // 0 is stop
            break;
          case "openVideoPlayer":
            if (typeof openVideoPlayer !== "undefined") {
              if (this.audioState != 0) {
                this.mediaControl("stopAudio");
              }
              openVideoPlayer.postMessage(this.question.video);
            }
            break;

          default:
            break;
        }
      } catch (error) {
        // do nothing
      }
    },
  },
};
</script>
<style scoped lang="scss">
.question {
  font-size: 1rem;
}

.article-content {
  padding: 16px;
  background: #f5f5f5;
  border-radius: 8px;
}
#articleContainer ::v-deep * img {
  max-width: 100%;
}

#questionContainer ::v-deep * img {
  max-width: 100%;
}

::v-deep .btn-close {
  position: fixed;
  top: 0px;
  right: 0px;
}
</style>